import { createSlice } from '@reduxjs/toolkit';
import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const { IDLE, LOADING, SUCCEEDED, FAILED } = REDUX_ASYNC_STATUSES;

const initialState = {
  policies: [],
  policiesStatus: IDLE,
  totalPolicies: 0,

  searchPoliciesResults: [],
  searchPoliciesStatus: IDLE,

  exportPoliciesStatus: IDLE,

  lastVisitedPolicyId: null
};

const policiesSlice = createSlice({
  name: 'policies',
  initialState,
  reducers: {
    getPolicies(state) {
      state.policiesStatus = LOADING;
    },
    getPoliciesSucceeded(state, action) {
      state.policies = action.payload.policies;
      state.totalPolicies = action.payload.total;
      state.policiesStatus = SUCCEEDED;
    },
    getPoliciesFailed(state) {
      state.policiesStatus = FAILED;
    },
    resetPolicies(state) {
      state.policies = [];
      state.policiesStatus = IDLE;
      state.totalPolicies = 0;
    },

    searchPolicies(state) {
      state.searchPoliciesStatus = LOADING;
    },
    searchPoliciesSucceeded(state, action) {
      state.searchPoliciesResults = action.payload;
      state.searchPoliciesStatus = SUCCEEDED;
    },
    searchPoliciesFailed(state) {
      state.searchPoliciesStatus = FAILED;
    },
    resetSearchPolicies(state) {
      state.searchPoliciesResults = [];
      state.searchPoliciesStatus = IDLE;
    },

    exportPolicies(state) {
      state.exportPoliciesStatus = LOADING;
    },
    exportPoliciesSucceeded(state) {
      state.exportPoliciesStatus = SUCCEEDED;
    },
    exportPoliciesFailed(state) {
      state.exportPoliciesStatus = FAILED;
    },

    setLastVisitedPolicyId(state, action) {
      state.lastVisitedPolicyId = action.payload.policyId;
    },
    resetLastVisitedPolicyId(state) {
      state.lastVisitedPolicyId = null;
    },

    reloadPolicies() {}
  }
});

export const {
  getPolicies,
  getPoliciesSucceeded,
  getPoliciesFailed,
  resetPolicies,
  searchPolicies,
  searchPoliciesSucceeded,
  searchPoliciesFailed,
  resetSearchPolicies,
  exportPolicies,
  exportPoliciesSucceeded,
  exportPoliciesFailed,
  setLastVisitedPolicyId,
  resetLastVisitedPolicyId,
  reloadPolicies
} = policiesSlice.actions;

export default policiesSlice.reducer;
